


























































































































import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import { TableHeader, Representative, CustomAttribute, CustomTile, ColumnSwitch, TaskDetailParam, TaskStatusDefault, TaskChildViewAttributeGroup, TaskAttributeGroup } from '@/@types/LibraryComponent';
import TaskDetailModal from '@/components/taskList/taskDetailModal/TaskDetailModalBase.vue';
import TaskGroupChildTable from '@/components/taskList/TaskGroupChildTable.vue';
import { TasksType } from '@/@types/Task';
import { vxm } from '@/store';
import { valueof } from '@/@types/Common';
import { AttributeCd } from '@/@types/constant';

@Component({
  components: {
    TaskDetailModal,
    TaskGroupChildTable,
  },
})
export default class TaskGroupView extends Vue {
  /** 担当者、実施者などの一覧 */
  @Prop({ required: true, default: [] })
  private readonly representatives!: Representative[];
  // 優先度リスト
  @Prop()
  private priorities!: TaskAttributeGroup[];
  // カテゴリーリスト
  @Prop()
  private categories!: TaskAttributeGroup[];
  @Prop()
  private statuses!: TaskAttributeGroup[];
  @Prop({ required: true, default: [] })
  private taskChildViewAttributeGroups!: TaskChildViewAttributeGroup[];
  @Prop({ required: true })
  private attributeTitle!: valueof<keyof typeof AttributeCd>;
  @Prop()
  private customAttributes!: CustomAttribute[];
  @Prop()
  private customTiles!: CustomTile[];
  @Prop()
  private fieldColumns!: ColumnSwitch[];
  private tasks: TasksType[] = [];
  private isOpenTaskDetailModal: boolean = false;
  private tasksFields: Array<TableHeader> = [
    { text: '担当者', value: 'person' },
    { text: 'ステータス', value: 'status' },
    { text: '優先度', value: 'priority' },
    { text: '期限日', value: 'limitDate' },
  ];
  private isOpenAll: boolean = true;

  private groupDisplay(group: TaskAttributeGroup): void {
    group.isOpenView = !group.isOpenView;
  }

  /** モーダルを開く */
  private openTaskModal() {
    this.isOpenTaskDetailModal = true;
  }

  /**
   * 表示中のタスク詳細モーダルを閉じる
   */
  private async closeTaskModal() {
    this.tasks.splice(0);
    this.isOpenTaskDetailModal = false;
    await vxm.theoryApi.tasksStore.fetchTasks({
      'project-id': this.projectId,
    });
  }

  private switchIsOpenAll(): void {
    this.isOpenAll = !this.isOpenAll;
  }

  private switchHelp(group: TaskAttributeGroup): void {
    group.isHelp = !group.isHelp;
  }

  private checkIsHelp(group: TaskAttributeGroup) {
    return group.isHelp;
  }

  private getTaskCountByStatus(group: TaskAttributeGroup) {
    if (status === 'noSet') {
      return this.getTasks.length;
    }
    const filteredTasks = this.getTasks.filter((task) => {
      return task.status === status;
    });
    return filteredTasks.length;
  }

  private getTaskCount(group: TaskAttributeGroup) {
    return this.filteredTasks(group.title, group.taskAttributeValueOptionId).length;
  }

  private getOpenClass(group: TaskAttributeGroup) {
    return {
      'open': group.isOpenView,
      'no-open': !group.isOpenView,
    };
  }

  private getPaddingClass(group: TaskAttributeGroup) {
    return {
      'py-2': group.isOpenView,
      'py-1': !group.isOpenView,
    };
  }

  private getOpenTextClass(group: TaskAttributeGroup) {
    return {
      opentext: group.isOpenView,
      noopentext: !group.isOpenView,
    };
  }

  private getStyle(group: TaskAttributeGroup) {
    return {
      background: group.backgroundColor,
      color: group.fontColor,
    };
  }

  private getFontcolor(group: TaskAttributeGroup) {
    return {
      color: group.fontColor,
    };
  }

  private filteredTasks(title: string | null, valueOptionId: number | null): TasksType[] {
    if (this.attributeTitle === AttributeCd.status) {
      if (title === 'noSet') {
        return this.getTasks.filter((task) => {
          return !task.status;
        });
      }
      return this.getTasks.filter((task) => {
        return task.status === title;
      });
    }
    if (this.attributeTitle === AttributeCd.category) {
      if (title === 'noSet') {
        return this.getTasks.filter((task) => {
          return !task.category;
        });
      }
      return this.getTasks.filter((task) => {
        return task.category === title;
      });
    }
    if (this.attributeTitle === AttributeCd.priority) {
      if (title === 'noSet') {
        return this.getTasks.filter((task) => {
          return !task.priority;
        });
      }
      return this.getTasks.filter((task) => {
        return task.priority === title;
      });
    }
    if (this.attributeTitle.toString().length === 10) {
      const attributeNumber = this.attributeTitle.toString().slice(-1);
      if (title === 'noSet') {
        return this.getTasks.filter((task) => {
          return task[`customAttribute${attributeNumber}ValueOption`] === null;
        });
      }
      return this.getTasks.filter((task) => {
        return task[`customAttribute${attributeNumber}ValueOption`] === valueOptionId;
      });
    }
    if (this.attributeTitle.toString().length === 11) {
      const attributeNumber = this.attributeTitle.toString().slice(-2);
      if (title === 'noSet') {
        return this.getTasks.filter((task) => {
          return task[`customAttribute${attributeNumber}ValueOption`] === null;
        });
      }
      return this.getTasks.filter((task) => {
        return task[`customAttribute${attributeNumber}ValueOption`] === valueOptionId;
      });
    }
    return [];
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get filteredGroup() {
    const filteredGroup = this.taskChildViewAttributeGroups.find((group) => {
      return group.attributeCd === this.attributeTitle;
    });
    return filteredGroup ? filteredGroup.attributes : [];
  }

  private get classOpenAll(): {
    open: boolean;
    'no-open': boolean;
  } {
    return {
      'open': this.isOpenAll,
      'no-open': !this.isOpenAll
    };
  }

  private get classPaddingAll(): {
    'py-2': boolean;
    'py-1': boolean;
  } {
    return {
      'py-2': this.isOpenAll,
      'py-1': !this.isOpenAll
    };
  }

  private get classOpenTextAll(): {
    opentext: boolean,
    noopentext: boolean
  } {
    return {
      opentext: this.isOpenAll,
      noopentext: !this.isOpenAll
    };
  }

  private get getTasks(): TasksType[] {
    const response = vxm.theoryApi.tasksStore.getTasks;
    if (response) {
      this.tasks = response.results;
      return this.tasks;
    } else return [];
  }

  @Emit('emitTaskData')
  private emitTaskData(value: TaskDetailParam): TaskDetailParam {
    return value;
  }

  @Emit('emitCustomAttributeAddModal')
  private emitCustomAttributeAddModal() {
    return;
  }
}
